<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.entrance.entranceName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="entranceId">
              <a-select v-model="model.entranceId" @change="entranceChange" :disabled="this.$store.getters.applicationCode != 'emp_platform'"
                        :placeholder="language['common.pleaseChoose']+language['emp.col.entrance.entranceName']" allowClear>
                <a-select-option v-for="(item,index) in entrancelist" :key="index.toString()" :value="item.id">
                  {{ item.entranceName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!--<a-col :span="24">
            <a-form-model-item label="父级栏目" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="parentColId" @change="parentColChange" allowClear>
                <a-select-option v-for="(item,index) in topCol" :key="index.toString()" :value="item.id">
                  {{ item.colName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.colCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="colCode">
              <a-input v-model="model.colCode" :placeholder="language['trmorder.auto']"  disabled></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.colName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="colName">
              <a-input v-model="model.colName" :placeholder="language['common.pleaseInput']+language['emp.col.colName']"  style="width: 80%" ></a-input>
              <a-button @click="languageModelOpen('emp_col_tbl','col_name',colNameLanguages)" type="primary"  style="left: 3%"  :disabled="formDisabled">{{language['common.language']}}</a-button>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['ad.image']" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-image-upload class="avatar-uploader" :text="language['common.uploadButton']" v-model="model.colImg" :upload-source="uploadSource" ></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.templateTypeName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="templateType">
              <j-dict-select-tag :placeholder="language['common.pleaseChoose']+language['emp.col.colName']" type="list" v-model="model.templateType" dictCode="emp_col_template_type"  :disabled="!!model.id"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.publishStatusName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishStatus">
<!--              <a-input v-model="model.publishStatus" placeholder="请输入发布状态"  ></a-input>-->
              <j-dict-select-tag v-model="model.publishStatus" :type="'radio'" dictCode="hhemp_publish_status" :readOnly="true" disabled/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
             <a-form-model-item :label="language['emp.col.publisher']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publisher" v-show="colVisible==true">
               <a-input v-model="model.publisher" placeholder=""  :readOnly="true" disabled></a-input>
             </a-form-model-item>
           </a-col>
           <a-col :span="24">
             <a-form-model-item :label="language['emp.col.publishTime']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishTime" v-show="colVisible==true">
               <j-date placeholder="" v-model="model.publishTime"  style="width: 100%" :readOnly="true" date-format="YYYY-MM-DD HH:mm:ss" />
             </a-form-model-item>
           </a-col>
          <!--<a-col :span="24">
            <a-form-model-item label="发布应用" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishApplications">
              <j-multi-select-tag type="checkbox" v-model="model.publishApplications" dictCode="hhemp_applications" placeholder="请选择发布应用" />
            </a-form-model-item>
          </a-col>-->

          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.contentNumber']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="detailNumber" v-show="colVisible==true">
              <a-input v-model="model.childNumber" placeholder="" style="width: 100%" :readOnly="true" disabled v-if="model.childNumber>0"/>
              <a-input v-model="model.contentNumber" placeholder="" style="width: 100%" :readOnly="true" disabled v-else/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.sortNo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
              <a-input-number :min="1" :max="9999" v-model="model.sortNo"  style="width: 100%" :placeholder="language['common.pleaseInput']+language['emp.col.sortNo']" :disabled="this.disabled"/>
            </a-form-model-item>
          </a-col>
<!--          <a-col :span="24">
            <a-form-model-item label="刪除标示" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="delFlag">
              <a-input v-model="model.delFlag" placeholder="请输入刪除标示"  ></a-input>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-input v-model="model.remark" :placeholder="language['common.pleaseInput']+language['emp.col.remark']"  style="width: 80%"></a-input>
              <a-button @click="languageModelOpen('emp_col_tbl','remark',remarkLanguages)" type="primary"  style="left: 3%"  :disabled="formDisabled">{{language['common.language']}}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
        <language-model ref="languageModel" @ok="languageOk"></language-model>
      </a-form-model>
    </j-form-container>
  </a-spin>

</template>

<script>

import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import LanguageModel from "@/components/LanguageModel"
export default {
  name: 'CmsColTblForm',
  components: {
    LanguageModel
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      parentColId:"",
      uploadSource:"hhemp",
      model:{},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
    /*colCode: [
    { required: true, message: '请输入栏位编号!'},
     { validator: (rule, value, callback) => validateDuplicateValue('cms_col_tbl', 'col_code', value, this.model.id, callback)},
        ],*/
        colName: [
          { required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['emp.col.colName']},
          /*{ pattern: /^.{6,18}$/, message: '请输入6到18位任意字符!'},*/
          /*{ validator: (rule, value, callback) => validateDuplicateValue('cms_col_tbl', 'col_name', value, this.model.id,'0', callback)},*/
          {max: 200, message: this.$store.getters.language['common.lengthUnder'] + '100', trigger: 'blur'}
        ],
        templateType: [
          { required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['emp.col.colName']},
        ],
        sortNo: [
          {required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['emp.col.sortNo']},
          /*{validator: this.validateToSortNo, trigger: 'blur'}*/
        ],
        entranceId:[{ required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['emp.col.entrance.entranceName']},]
    /*publishStatus: [
      { required: true, message: '请输入发布状态!'},
        ]*/
      },
      url: {
        add: "/hhemp/col/cmscoltbl",
        edit: "/hhemp/col/cmscoltbl",
        queryById: "/hhemp/col/cmscoltbl/"
      },
      colVisible: false,
      entrancelist:[],
      colNameLanguages:[],
      remarkLanguages:[],
      
    }
  },
  computed: {
    formDisabled(){
      return this.disabled
    },
    language() {
      return this.$store.getters.language
    },
  },
  created () {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model));
    this.initEntrancelist();
  },
  methods: {
    languageOk(map) {
      if (map && map.dataColumn == 'col_name') {
        this.colNameLanguages = map.languagelist;
      }
      if (map && map.dataColumn == 'remark') {
        this.remarkLanguages = map.languagelist;
      }
    },
    initEntrancelist(){
      getAction("/hhemp/entrance/empcmsentrances",{"status":"Y"}).then(res=>{
        if(res.success){
          this.entrancelist = res.result;
        }
      })
    },
    languageModelOpen(dataTable, dataColumn, languagelist) {
      this.$refs.languageModel.edit(this.$store.getters.applicationCode, dataTable, dataColumn, this.model.id, languagelist, this.disabled);
    },
    initLanguagetemp(dataTable, dataColumn, dataId) {
      getAction("/sys/syslanguagedata/querylistby", {
        applicationCode: this.$store.getters.applicationCode,
        dataTable: dataTable,
        dataColumn: dataColumn,
        dataId: dataId
      }).then((res) => {
        if (res.success) {
          if (dataColumn == 'col_name') {
            this.colNameLanguages = res.result;
          }
          if (dataColumn == 'remark') {
            this.remarkLanguages = res.result;
          }
        }
      })
    },
    add () {
      //this.edit(this.modelDefault);
      if(this.$store.getters.applicationCode != 'emp_platform'){
        getAction("/hhemp/entrance/empcmsentrances",{entranceCode:this.$store.getters.applicationCode}).then(res=>{
          if(res.success){
            let list = [...res.result]
            if(list!=null&&list.length>0){
              this.edit({publishStatus:'unpublished',entranceId:list[0].id});
            }
          }
        })
      }else{
        this.edit({publishStatus:'unpublished'});
      }
      this.colVisible = false;
    },
    edit (record) {
      this.initLanguagetemp('emp_col_tbl', 'col_name', record.id)
      this.initLanguagetemp('emp_col_tbl', 'remark', record.id)
      this.model = Object.assign({}, record);
      this.visible = true;
      this.colVisible = true;
      // this.initTopCol(this.model.entranceId)
      // this.parentColId = record.parentColId
    },
    submitForm () {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          // this.model.parentColId = this.parentColId
          if(!this.model.id){
            httpurl+=this.url.add;
            method = 'post';
          }else{
            httpurl+=this.url.edit;
            method = 'put';
          }
          this.model.colLevel = '1';
          this.model.colNameLanguages=this.colNameLanguages;
          this.model.remarkLanguages=this.remarkLanguages
          httpAction(httpurl,this.model,method).then((res)=>{
            if(res.success){
              that.$message.success(res.message);
              that.$emit('ok');
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }

      })
    },
    validateToSortNo(rule, value, callback){
      if(value<1||value>500){
        callback("输入的值在1到500之间！");
      }
    },
  }
}
</script>
